// Texts for the world 'socks': the name on the map, the level titles and the comic words in the scene (scene.ts), per language.
// The ids must be the level ids in levels.ts (npm run validate checks this); other languages must have the same ids as da (tsc).
import { defineWorldStrings } from '../../core/i18n';

export const strings = defineWorldStrings({
  da: {
    name: 'Sokkeskuffen',
    levels: {
      'first-hop': { title: 'Første hop' },
      'slingshot': { title: 'Slangebøssen' },
      'wool-sock': { title: 'Uldsokken' },
      'long-shot': { title: 'Langt skud' },
      'short-shot': { title: 'Kort skud' },
      'out-of-the-hole': { title: 'Op af hullet' },
      'stop-the-hop': { title: 'Stop hoppet' },
      'crooked-hop': { title: 'Skævt hop' },
      'over-the-dresser': { title: 'Over kommoden' },
      'double-hop': { title: 'Dobbelt hop' },
      'soft-landing': { title: 'Blød landing' },
      'bank-shot': { title: 'Bandehop' },
      'pair-of-socks': { title: 'Et par sokker' },
      'ball-of-yarn': { title: 'Garnnøglen' },
      'master': { title: 'Mester' },
    },
    scene: {
      'where': 'HVOR?',
    },
  },
  en: {
    name: 'The sock drawer',
    levels: {
      'first-hop': { title: 'First hop' },
      'slingshot': { title: 'The catapult' },
      'wool-sock': { title: 'The woolly sock' },
      'long-shot': { title: 'Long shot' },
      'short-shot': { title: 'Short shot' },
      'out-of-the-hole': { title: 'Out of the hole' },
      'stop-the-hop': { title: 'Stop the hop' },
      'crooked-hop': { title: 'Wonky hop' },
      'over-the-dresser': { title: 'Over the chest of drawers' },
      'double-hop': { title: 'Double hop' },
      'soft-landing': { title: 'Soft landing' },
      'bank-shot': { title: 'Bank shot' },
      'pair-of-socks': { title: 'A pair of socks' },
      'ball-of-yarn': { title: 'The ball of wool' },
      'master': { title: 'Master' },
    },
    scene: {
      'where': 'WHERE?',
    },
  },
});
